module.exports = __webpack_public_path__ + "static/media/3-施工安全管理系统.fcad4a64.png";